import { render, staticRenderFns } from "./ExemptionView.vue?vue&type=template&id=4150ad32&"
import script from "./ExemptionView.vue?vue&type=script&lang=js&"
export * from "./ExemptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports